/** Default format used when both date and time are shown (`showTimeInput={true}`). */
export const DEFAULT_DATE_TIME_FORMAT = 'MM-dd-yyyy hh:mm aa';

/**
 * Error-type keys delivered to the `onValidationUpdate` callback when the user
 * types an invalid date into a `<Calendar>` input. Use these to conditionally
 * display different error messages in a `<FieldDescription>`.
 *
 * - `INVALID_DATE_FORMAT` — the typed string does not match `dateFormat`
 * - `INVALID_MONTH_FORMAT` — the month portion is outside 1–12
 * - `LESS_THAN_MIN_DATE` — the date is earlier than `minDate`
 * - `GREATER_THAN_MAX_DATE` — the date is later than `maxDate`
 */
export const ERROR_TYPES = {
    INVALID_DATE_FORMAT: 'INVALID_DATE_FORMAT',
    INVALID_MONTH_FORMAT: 'INVALID_MONTH_FORMAT',
    LESS_THAN_MIN_DATE: 'LESS_THAN_MIN_DATE',
    GREATER_THAN_MAX_DATE: 'GREATER_THAN_MAX_DATE',
} as const;

/** Union of `ERROR_TYPES` values, used as the first argument to `onValidationUpdate`. */
export type ErrorType = (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];

export const ERROR_MESSAGES = {
    INVALID_MONTH_FORMAT: 'Please make sure the month you entered is a value from 1 to 12.',
    INVALID_DATE_FORMAT: (currentDate: string) =>
        `Invalid date. Please re-enter the date in the correct format (e.g. ${currentDate})`,
    OUT_OF_RANGE: (minYear: number, maxDateValue: string) =>
        `Please enter a date between ${minYear} and ${maxDateValue}.`,
};
